

// PROGRESS BAR
(function() {
    var bar = document.querySelector('#mm-reading-progress .mm-reading-progress__bar');
    if (!bar) return;
    
    function updateProgress() {
        var doc = document.documentElement;
        var scrollTop = window.pageYOffset || doc.scrollTop || 0;
        var scrollHeight = (doc.scrollHeight || 0) - window.innerHeight;
    
        var ratio = scrollHeight > 0 ? (scrollTop / scrollHeight) : 0;
        var pct = Math.max(0, Math.min(100, ratio * 100));
        bar.style.width = pct + '%';
    }
    
    // Premier calcul + écouteurs
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    })();
    
    
    // CHAPITRAGE
    (function() {
      /* ========= Réglages ========= */
      var CONTENT_SELECTORS = [
        '.mm-article-content-block-container',
        '.article-template__content',
        '.rte',
        '.article__content',
        '.mm-article'
      ];
      var headerOffset = 100; // ajuste à la hauteur de ton header sticky
    
      /* ========= Trouver le contenu de l’article ========= */
      var contentEl = null;
      for (var i = 0; i < CONTENT_SELECTORS.length; i++) {
        var el = document.querySelector(CONTENT_SELECTORS[i]);
        if (el) { contentEl = el; break; }
      }
      if (!contentEl) contentEl = document.querySelector('main') || document.body;
    
      /* ========= Récupérer les H2 et éléments data-mm-toc ========= */
      var headings = Array.prototype.slice.call(contentEl.querySelectorAll('h2, [data-mm-toc]'));
      if (!headings.length) { return; } // pas de chapitres, on sort
    
      /* ========= Créer/obtenir le conteneur TOC ========= */
      var toc = document.getElementById('mm-toc');
      if (!toc) {
        toc = document.createElement('nav');
        toc.id = 'mm-toc';
        toc.setAttribute('aria-label', 'Chapitres de l’article');
        toc.innerHTML = '<ol class="mm-toc__list"></ol>';
        // insérer le TOC avant le contenu
        contentEl.parentNode.insertBefore(toc, contentEl);
      }
      var list = toc.querySelector('.mm-toc__list');
      if (!list) {
        list = document.createElement('ol');
        list.className = 'mm-toc__list';
        toc.appendChild(list);
      }
    
      /* ========= Layout : placer TOC | contenu ========= */
      var parent = toc.parentElement;
      if (parent && !parent.classList.contains('mm-article-layout')) {
        parent.classList.add('mm-article-layout');
      }
    
      /* ========= Utilitaires ========= */
      var used = {};
      function slugify(text) {
        return (text || '')
          .toString()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // retire accents
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '') || 'section';
      }
      function uniqueId(base) {
        var id = base, n = 2;
        while (used[id] || document.getElementById(id)) {
          id = base + '-' + n++;
        }
        used[id] = true;
        return id;
      }
    
      /* ========= Construire le TOC ========= */
      var links = [];
      headings.forEach(function(h, idx) {
        var title = (h.textContent || h.innerText || '').trim();
        var base = slugify(title) || ('chapitre-' + (idx + 1));
        var id = h.id ? h.id : uniqueId(base);
        if (!h.id) h.id = id;
    
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'mm-toc__link';
        a.href = '#' + id;
        a.setAttribute('data-target', id);

        var badge = document.createElement('span');
        badge.className = 'mm-toc__badge';
        badge.textContent = String(idx + 1).padStart(2, '0');

        var text = document.createElement('span');
        text.className = 'mm-toc__text';
        text.textContent = title;

        a.appendChild(badge);
        a.appendChild(text);
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });
    
      /* ========= Activation visuelle ========= */
      var activeLink = null;
      function setActive(id) {
        if (!id) return;
        if (activeLink && activeLink.getAttribute('data-target') === id) return;
        links.forEach(function(a) {
          var match = a.getAttribute('data-target') === id;
          a.parentElement.classList.toggle('is-active', match);
          if (match) {
            a.setAttribute('aria-current', 'true');
            activeLink = a;
          } else {
            a.removeAttribute('aria-current');
          }
        });
        // garder l'actif visible dans le panneau
        if (activeLink) {
          var linkBox = activeLink.getBoundingClientRect();
          var listBox = list.getBoundingClientRect();
          if (linkBox.top < listBox.top || linkBox.bottom > listBox.bottom) {
            activeLink.scrollIntoView({ block: 'nearest' });
          }
        }
      }
    
      /* ========= Défilement précis + activation immédiate ========= */
      function activateAndScroll(id) {
        setActive(id); // activation instantanée
        var target = document.getElementById(id);
        if (!target) return;
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id); // maj URL sans jump
      }
    
      // clic sur le TOC
      list.addEventListener('click', function(e) {
        var a = e.target.closest('a.mm-toc__link');
        if (!a) return;
        e.preventDefault();
        var id = a.getAttribute('data-target');
        activateAndScroll(id);
      });
    
      // navigation via hash (ex: back/forward)
      window.addEventListener('hashchange', function() {
        var id = (location.hash || '').slice(1);
        if (id && document.getElementById(id)) {
          setActive(id);
        }
      });
    
      /* ========= Suivi du scroll (IntersectionObserver) ========= */
      var observer;
      var mapIdByHeading = new WeakMap();
      var options = {
        root: null,
        rootMargin: '-' + headerOffset + 'px 0px -66% 0px', // fenêtre d’activation
        threshold: 0
      };
    
      function initObserver() {
        observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              setActive(mapIdByHeading.get(entry.target));
            }
          });
        }, options);
    
        headings.forEach(function(h) {
          mapIdByHeading.set(h, h.id);
          observer.observe(h);
        });
      }
    
      try {
        initObserver();
      } catch (err) {
        // Fallback : calcul sur scroll
        function onScroll() {
          var pos = window.scrollY + headerOffset + (window.innerHeight * 0.33);
          var currentId = headings[0].id;
          headings.forEach(function(h) {
            if (h.offsetTop <= pos) currentId = h.id;
          });
          setActive(currentId);
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }
    
      /* ========= Initialisation de l’état actif ========= */
      var initialId = (location.hash || '').replace('#', '');
      if (initialId && document.getElementById(initialId)) {
        setActive(initialId);
      } else {
        setActive(headings[0].id);
      }
    })();
    